import { FC } from "react";
import ModuleConfigurationSection from "./components/ModuleConfigurationSection";
import ModuleLayoutSection from "./components/ModuleLayoutSection";

const PromotionSection: FC = () => {
  return (
    <>
      <ModuleLayoutSection />
      <ModuleConfigurationSection />
    </>
  );
};

export default PromotionSection;
